import type { CreateNewTaskRequest } from '@witmetrics/api-client';
import { createProjectTask as coreCreateProjectTask } from '@witmetrics/unison-core';
import { API } from '@/api';

export const createProjectTask = (
  projectId: number,
  data: CreateNewTaskRequest
) => coreCreateProjectTask(API, projectId, data);
